import * as THREE from 'three';

/**
 * Given a screen fraction (0=left, 0.5=center, 1=right), camera, and distance from camera,
 * returns the corresponding focal offset X in world units.
 */
export function focalOffsetXForScreenFrac(frac: number, camera: THREE.Camera, distance: number): number {
  // frac: 0..1  (0=left, 0.5=center, 1=right)
  const ndcX = 2 * frac - 1; // [-1, 1]

  if ((camera as THREE.PerspectiveCamera).isPerspectiveCamera) {
    const cam = camera as THREE.PerspectiveCamera;
    const halfHeightAtDist = Math.tan(THREE.MathUtils.degToRad(cam.fov) / 2) * distance;
    const halfWidthAtDist = halfHeightAtDist * cam.aspect;
    return ndcX * halfWidthAtDist; // world units along camera's right axis
  }

  if ((camera as THREE.OrthographicCamera).isOrthographicCamera) {
    const cam = camera as THREE.OrthographicCamera;
    const halfWidthWorld = (cam.right - cam.left) / (2 * cam.zoom);
    return ndcX * halfWidthWorld;
  }

  return 0;
}